import { render } from "./settings-create-asset.vue?vue&type=template&id=26c8ada7"
import script from "./settings-create-asset.vue?vue&type=script&lang=js"
export * from "./settings-create-asset.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Usuario\\Documents\\Git-Repositorios\\edge_frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__